import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { EcosystemAPI, LIFECYCLE_STATES, STATE_LABELS, mapServerError, canCreateEntity } from "../../lib/ecosystemApi";
import { LifecycleChip } from "../../components/ecosystem/Chips";
import { useAuth } from "../../lib/auth";

export default function Overview() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [err, setErr] = useState(null);

  useEffect(() => {
    EcosystemAPI.list().then(setItems).catch((e) => setErr(mapServerError(e)));
  }, []);

  const counts = LIFECYCLE_STATES.reduce((acc, s) => {
    acc[s] = items.filter((i) => i.lifecycle_state === s).length;
    return acc;
  }, {});
  const reviewDepth = counts.REVIEW || 0;
  const myDrafts = items.filter((i) => i.created_by === user?.id && i.lifecycle_state === "DRAFT").length;

  return (
    <div className="space-y-6" data-testid="ecosystem-overview">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold text-slate-900">Overview</h1>
        {canCreateEntity(user) && (
          <Link
            to="/ecosystem/entities/new"
            data-testid="ecosystem-new-entity"
            className="px-3 py-1.5 text-sm rounded bg-slate-900 text-white"
          >
            New entity
          </Link>
        )}
      </div>

      {err && <div className="text-sm text-red-700" data-testid="overview-error">{err}</div>}

      <section>
        <h2 className="text-sm font-medium text-slate-600 mb-2">Lifecycle counts</h2>
        <div className="grid grid-cols-3 md:grid-cols-5 gap-3">
          {LIFECYCLE_STATES.map((s) => (
            <div
              key={s}
              data-testid={`overview-count-${s}`}
              className="p-3 bg-white rounded border flex flex-col gap-1"
            >
              <LifecycleChip state={s} />
              <div className="text-2xl font-semibold text-slate-900">{counts[s]}</div>
              <div className="text-xs text-slate-500">{STATE_LABELS[s]}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="grid md:grid-cols-2 gap-3">
        <div className="p-4 bg-white rounded border">
          <div className="text-sm text-slate-500">My drafts</div>
          <div className="text-3xl font-semibold" data-testid="overview-my-drafts">{myDrafts}</div>
        </div>
        <div className="p-4 bg-white rounded border">
          <div className="text-sm text-slate-500">Review queue depth</div>
          <div className="text-3xl font-semibold" data-testid="overview-review-depth">{reviewDepth}</div>
        </div>
      </section>
    </div>
  );
}
